import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-999999 flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "absolute inset-0 bg-black/70" }, null, -1),
    _createElementVNode("div", { class: "relative" }, [
      _createElementVNode("div", { class: "animate-spin rounded-full border-4 border-yellow-400 border-t-transparent h-36 w-36" })
    ], -1)
  ]))], 512)), [
    [_vShow, _ctx.GeneralInstance.isLoading]
  ])
}